(function ($) {
    const ajaxUrl = ajax_filter_params.ajax_url;
    const pageId = wpData.page_id;

    const filter_bachelor = {
        122: 'filter_bachelor',
        120: 'filter_master'
    }[pageId] || 'filter_posts';

    const form = $('#ajax-filter-form');
    const filterResults = $('#filter-results');

    let updateURL = false;

    function reloadPosts(data = {}) {
        $.ajax({
            url: ajaxUrl,
            method: 'POST',
            data: { action: filter_bachelor, ...data },
            success(response) {
                filterResults.html(response);
            },
        });
    }

    function addTag(label, tagValue) {
        $('.selected_tags_container').each(function () {
            const $container = $(this);
            if ($container.find(`[data-value="${tagValue}"]`).length === 0) {
                $('<span>')
                    .addClass('filter-tag')
                    .attr('data-value', tagValue)
                    .text(`${label} ✕`)
                    .appendTo($container);
            }
        });

        if ($('.selected_tags_container .filter-tag').length > 0) {
            $('#tags-container').show();
        }
    }

    function removeTag(tagValue) {
        $('.selected_tags_container').find(`[data-value="${tagValue}"]`).remove();

        if ($('.selected_tags_container .filter-tag').length === 0) {
            $('#tags-container').hide();
        }
    }

    function initializeFiltersFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        const data = {};

        urlParams.forEach((value, key) => {
            const checkbox = form.find(`input[name="${key}[]"][value="${value}"]`);
            if (checkbox.length) {
                checkbox.prop('checked', true);
                const label = checkbox.closest('label').text().trim();
                addTag(label, value);
                data[key] = data[key] || [];
                data[key].push(value);
            }
        });

        if (Object.keys(data).length > 0) {
            reloadPosts({ form_data: form.serialize() });
            updateURL = true;
        } else {
            reloadPosts({ action: filter_bachelor });
        }

        if ($('.selected_tags_container .filter-tag').length === 0) {
            $('#tags-container').hide();
        }
    }

    form.on('change', 'input[type="checkbox"]', function () {
        const checkbox = $(this);
        const label = checkbox.closest('label').text().trim();
        const tagValue = checkbox.val();

        if (checkbox.is(':checked')) {
            addTag(label, tagValue);
        } else {
            removeTag(tagValue);
        }

        const data = form.serialize();
        reloadPosts({ form_data: data });

        if (updateURL) {
            const params = new URLSearchParams();
            form.find('input[type="checkbox"]:checked').each(function () {
                const name = $(this).attr('name').replace('[]', '');
                const value = $(this).val();
                params.append(name, value);
            });
            window.history.pushState({}, '', '?' + params.toString());
        }
    });

    $(document).on('click', '.filter-tag', function () {
        const tag = $(this);
        const tagValue = tag.data('value');

        form.find(`input[value="${tagValue}"]`).prop('checked', false);
        removeTag(tagValue);

        const data = form.serialize();
        reloadPosts({ form_data: data });

        if (updateURL) {
            const params = new URLSearchParams();
            form.find('input[type="checkbox"]:checked').each(function () {
                const name = $(this).attr('name').replace('[]', '');
                const value = $(this).val();
                params.append(name, value);
            });
            window.history.pushState({}, '', '?' + params.toString());
        }
    });

    $('#clear-filters').on('click', () => {
        form.find('input[type="checkbox"]').prop('checked', false);
        $('.selected_tags_container').empty();
        $('#tags-container').hide();
        reloadPosts({ action: filter_bachelor });

        if (updateURL) {
            window.history.pushState({}, '', window.location.pathname);
        }
    });

    form.on('clear-filters', function () {
        form.find('input[type="checkbox"]').prop('checked', false);
        $('.selected_tags_container').empty();
        $('#tags-container').hide();
        reloadPosts({ action: filter_bachelor });

        if (updateURL) {
            window.history.pushState({}, '', window.location.pathname);
        }
    });

    initializeFiltersFromURL();
})(jQuery);
